import { HTMLAttributes, type JSX } from "react";
import { CreateOption } from "./GenericAutocompleteTypes";

export class GenericAutocompleteUtils {
    public static renderOptionCreateMode(props: HTMLAttributes<HTMLLIElement>, option: CreateOption, optionLabel: string, addText: string): JSX.Element {
        if (option.createdValue) {
            return (
                <li {...props} key={`${optionLabel}-${option.id}`}>
                    {addText} {option.createdValue}
                </li>
            );
        }
        return (
            <li {...props} key={`${optionLabel}-${option.id}`}>
                {optionLabel}
            </li>
        );
    }

    public static getOptionLabelCreateMode(option: CreateOption, optionLabel: string): string {
        if (option.createdValue) {
            return option.createdValue;
        }
        return optionLabel || "";
    }
}
